import {
  InsufficientAccessBackground,
  ProjectMilestoneDetailSection,
  ProjectMilestoneHeaderSection,
  StyledActivityCardBackground,
  useAccessState
} from 'modules';
import React from 'react';



export type ProjectMilestoneActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const ProjectMilestoneActivity = (props: ProjectMilestoneActivityProps) => {
  const access = useAccessState('Milestone');
  if (!access.view) {
    return (
      <InsufficientAccessBackground.FC />
    );
  }
  return (
    <StyledActivityCardBackground.FC>
      <ProjectMilestoneHeaderSection.FC />
      <ProjectMilestoneDetailSection.FC />
    </StyledActivityCardBackground.FC>
  );
};
